<script>
  import { inertia, router } from '@inertiajs/svelte';
  import Icon from '@iconify/svelte';
  import AppLayout from '../../components/AppLayout.svelte';
  import Card from '../../components/ui/Card.svelte';
  import Button from '../../components/ui/Button.svelte';
  import ConfirmDialog from '../../components/ui/ConfirmDialog.svelte';
  import PlatformBadge from '../../components/ui/PlatformBadge.svelte';
  import StatusBadge from '../../components/StatusBadge.svelte';

  let { calendar, social_accounts = [], posts = [] } = $props();

  let confirmingDelete = $state(false);

  function destroy() {
    confirmingDelete = false;
    router.delete(`/calendars/${calendar.id}`);
  }

  function when(post) {
    if (post.scheduled_at) return `Scheduled ${new Date(post.scheduled_at).toLocaleString()}`;
    return `Created ${new Date(post.created_at).toLocaleDateString()}`;
  }
</script>

<AppLayout title={calendar.name}>
  <div class="flex items-center justify-between mb-6">
    <a use:inertia href="/calendars" class="text-sm text-secondary-500 hover:text-primary-600 flex items-center gap-1">
      <Icon icon="mdi:arrow-left" /> Back to calendars
    </a>
    <div class="flex items-center gap-3">
      <Button href={`/calendars/${calendar.id}/edit`} variant="ghost"><Icon icon="mdi:pencil-outline" class="mr-1" /> Rename</Button>
      <Button variant="danger" onclick={() => { confirmingDelete = true; }}><Icon icon="mdi:delete-outline" class="mr-1" /> Delete</Button>
    </div>
  </div>

  <ConfirmDialog
    open={confirmingDelete}
    title="Delete this calendar?"
    body="Only possible while it has no accounts, posts, bins, or slots."
    confirmLabel="Delete"
    onconfirm={destroy}
    oncancel={() => { confirmingDelete = false; }}
  />

  <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
    <Card title="Accounts" aug={null}>
      {#if social_accounts.length === 0}
        <div class="text-center py-6">
          <p class="text-secondary-500 text-sm mb-3">No accounts in this calendar yet.</p>
          <Button href="/social_accounts/new" variant="secondary">Connect an account</Button>
        </div>
      {:else}
        <ul class="flex flex-col gap-2">
          {#each social_accounts as acc}
            <li class="flex items-center gap-2 text-sm">
              <PlatformBadge platform={acc.platform} handle={acc.handle} />
            </li>
          {/each}
        </ul>
      {/if}
    </Card>

    <div class="lg:col-span-2">
      <Card title="Posts">
        {#if posts.length === 0}
          <div class="text-center py-8">
            <Icon icon="mdi:pencil-outline" class="text-4xl text-secondary-300 mx-auto mb-3" />
            <p class="text-secondary-500">No posts in this calendar yet.</p>
          </div>
        {:else}
          <ul class="flex flex-col divide-y divide-secondary-100">
            {#each posts as post}
              <li class="py-3 first:pt-0 last:pb-0">
                <a use:inertia href={`/posts/${post.id}`} class="flex items-start justify-between gap-3 group">
                  <div class="min-w-0">
                    <p class="text-sm text-secondary-700 group-hover:text-primary-700 mb-1">{post.body}</p>
                    <div class="flex items-center gap-2 text-xs text-secondary-400">
                      <Icon icon="mdi:clock-outline" />
                      {when(post)}
                    </div>
                  </div>
                  <StatusBadge status={post.status} />
                </a>
              </li>
            {/each}
          </ul>
        {/if}
      </Card>
    </div>
  </div>
</AppLayout>
